import * as React from 'react';
import { TPAComponentsConsumer } from '../../TPAComponentsConfig';
import { st, classes } from './ActionsMenuLayoutItem.deprecated.st.css';
import { Text } from '../../Text';
import { ACTIONS_MENU_ITEM_DATA_HOOK } from '../dataHooks';
import { isSelectKey } from '../../../common/keyCodes';
import { shellClasses } from '../../../common/shellClasses';
/** ActionsMenuLayout */
export class ActionsMenuLayoutItem extends React.Component {
    constructor() {
        super(...arguments);
        this.liRef = React.createRef();
        this._onKeyDown = (e) => {
            if (!this.props.disabled && isSelectKey(e)) {
                e.preventDefault();
                this.props.onClick();
            }
        };
    }
    focus() {
        if (this.liRef.current) {
            this.liRef.current.focus();
        }
    }
    render() {
        const { content, prefixIcon, subtitle, disabled, onClick, alignment, className, } = this.props;
        return (React.createElement(TPAComponentsConsumer, null, ({ mobile, rtl }) => (React.createElement("li", { onKeyDown: this._onKeyDown, "aria-label": this.props['aria-label'], tabIndex: -1, ref: this.liRef, key: content, className: st(classes.root, { mobile, rtl, disabled, alignment, withIcon: !!prefixIcon }, className, shellClasses.hasCustomFocus), role: "menuitem", "aria-disabled": disabled, "data-hook": ACTIONS_MENU_ITEM_DATA_HOOK, "data-content": content, onClick: disabled ? undefined : onClick },
            React.createElement("div", { className: classes.container },
                prefixIcon ? (React.createElement("div", { className: classes.iconContainer },
                    React.createElement("div", { className: classes.icon }, prefixIcon))) : null,
                React.createElement("div", { className: classes.textContainer },
                    React.createElement("div", { className: classes.text },
                        React.createElement(Text, { className: classes.content }, content),
                        subtitle && (React.createElement(Text, { className: classes.subtitle }, subtitle)))))))));
    }
}
ActionsMenuLayoutItem.displayName = 'ActionsMenuLayout.Item';
//# sourceMappingURL=ActionsMenuLayoutItem.js.map